import { useOrderSet } from "@repo/data-store";
import { usePresentedOrderSet } from "@/lib/use-order-set-presentation";
import { OrderSetTimeline } from "@/shared/order-set-timeline/order-set-timeline";
import { StepProcedures } from "@/shared/order-set-timeline/step-procedures";

const ignoreChange = () => {};

/** Show the same authored timing as the plan editor, without booking-time edits. */
export function SessionTimeline({ orderSetId }: { orderSetId: string }) {
  const presentation = usePresentedOrderSet(useOrderSet({ orderSetId }));

  if (presentation.status !== "ready") {
    return (
      <output className="text-xs text-muted-foreground">
        {presentation.status === "missing" ? "Session timeline unavailable." : "Loading session timeline…"}
      </output>
    );
  }

  const orderSet = presentation.data;
  return (
    <OrderSetTimeline
      orderSet={orderSet}
      editable={false}
      readOnly
      selectedStepId={null}
      onSelectionChange={ignoreChange}
      onStepsChange={ignoreChange}
      onEnvelopeChange={undefined}
      renderStepProcedures={(stepId) => <StepProcedures steps={orderSet.steps} stepId={stepId} editable={false} />}
    />
  );
}
